import pageClass from '@/unit/pageClass'

class searchFrom extends pageClass {
  constructor(type) {
    super()
    if (type === 'form') {
      this.deep = ''
      this.name = ''
      this.pid = ''
    }
  }
}
export default searchFrom
